import React from 'react';

// Simple animated SVG checkmark
export default function SuccessAnimation() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
      <svg width="80" height="80" viewBox="0 0 80 80">
        <circle cx="40" cy="40" r="35" fill="#fff" stroke="#D4AF37" strokeWidth="5"/>
        <polyline
          points="25,43 37,55 55,30"
          fill="none"
          stroke="#27ae60"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            strokeDasharray: 48,
            strokeDashoffset: 0,
            animation: 'dash 0.7s ease forwards'
          }}
        />
        <style>{`
          @keyframes dash {
            from { stroke-dashoffset: 48; }
            to { stroke-dashoffset: 0; }
          }
        `}</style>
      </svg>
    </div>
  );
}
